/**
 * DealQuickInfoCard - Card de informação compacto para sidebar
 * Visual minimalista estilo ClickUp/Linear
 * 
 * Versão: 1.0.0
 */
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

// Props do componente
interface DealQuickInfoCardProps {
  icon: LucideIcon;
  label: string;
  value: React.ReactNode;
  className?: string;
  iconClassName?: string;
  onClick?: () => void;
}

/**
 * Card compacto de informação para sidebar
 */
export function DealQuickInfoCard({ 
  icon: Icon,
  label,
  value,
  className,
  iconClassName,
  onClick
}: DealQuickInfoCardProps) {
  const Wrapper = onClick ? 'button' : 'div';

  return (
    <Wrapper
      className={cn(
        'flex items-center gap-2 py-1.5 w-full text-left',
        onClick && 'hover:bg-muted/50 rounded-md px-1 -mx-1 transition-colors cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      <Icon className={cn('h-3.5 w-3.5 text-muted-foreground shrink-0', iconClassName)} />
      <span className="text-xs text-muted-foreground shrink-0">{label}</span>
      <span className="text-xs font-medium ml-auto truncate">{value}</span>
    </Wrapper>
  );
}
